import { useState } from 'react';

const HAIR_OPTIONS = {
  female: [
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlhair1.webp', label: 'white' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlhair2.webp', label: 'brown' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlhair3.webp', label: 'blue' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlhair4.webp', label: 'black' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlhair5.webp', label: 'red' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlhair6.webp', label: 'pink' }
  ],
  male: [
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboyhair1.webp', label: 'Buzz Cut' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboyhair2.webp', label: 'Short Fade' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboyhair3.webp', label: 'Braided Style' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboyhair4.webp', label: 'Man Bun' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboyhair5.webp', label: 'Medium Layered' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboyhair6.webp', label: 'Classic Slicked Back' }
  ],
  trans: [
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranshair1.webp', label: 'Waves' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranshair2.webp', label: 'Bangs' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranshair3.webp', label: 'Curls' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranshair4.webp', label: 'Bun' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranshair5.webp', label: 'Ponytail' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranshair6.webp', label: 'Twin Tails' }
  ],
  creature: [
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/1hair.webp', label: 'Blue' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/2hair.webp', label: 'Brown' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/3hair.webp', label: 'Black' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/4hair.webp', label: 'Red' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/5hair.webp', label: 'Yellow' }
  ]
};

const EYE_OPTIONS = {
  female: [
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirleye1.webp', label: 'blue' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirleye2.webp', label: 'brown' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirleye3.webp', label: 'green' }
  ],
  male: [
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboyeye1.webp', label: 'blue' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboyeye2.webp', label: 'brown' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboyeye3.webp', label: 'green' }
  ],
  trans: [
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranseye1.webp', label: 'blue' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranseye2.webp', label: 'brown' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranseye3.webp', label: 'green' }
  ],
  creature: [
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/eye1.webp', label: 'Yellow' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/eye2.webp', label: 'Red' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/eye3.webp', label: 'Green' }
  ]
};

const HEADINGS = {
  female: 'Customize Her Look',
  male: 'Customize His Look',
  trans: 'Customize Their Look',
  creature: 'Customize Her Look'
};

const Step4Appearance = ({ formData, updateFormData, goToStep }) => {
  const isCreature = formData.gender === 'creature';
  const hairFieldName = isCreature ? 'hairscolor' : 'hairstyle';
  const [selectedHair, setSelectedHair] = useState(formData.extraFields[hairFieldName] || '');
  const [selectedEye, setSelectedEye] = useState(formData.extraFields.eyeColor || '');
  
  const hairOptions = HAIR_OPTIONS[formData.gender] || [];
  const eyeOptions = EYE_OPTIONS[formData.gender] || [];
  const heading = HEADINGS[formData.gender] || 'Customize Look';

  const handleHairSelect = (hairLabel) => {
    setSelectedHair(hairLabel);
    updateFormData(`extraFields.${hairFieldName}`, hairLabel);
  };

  const handleEyeSelect = (eyeLabel) => {
    setSelectedEye(eyeLabel);
    updateFormData('extraFields.eyeColor', eyeLabel);
  };

  const handleNext = () => {
    if (selectedHair && selectedEye) {
      goToStep(5);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '80px 20px 40px',
      position: 'relative',
      overflowY: 'auto'
    }}>
      {/* Background images */}
      <img 
        src="https://customer-assets.emergentagent.com/job_d690f70b-574f-42dc-be44-392b85b82530/artifacts/s2zgc1ad_nowings.png" 
        alt="Background Left" 
        className="bg-image-left"
      />
      <img 
        src="https://customer-assets.emergentagent.com/job_d690f70b-574f-42dc-be44-392b85b82530/artifacts/h9eorbzw_female6.png" 
        alt="Background Right" 
        className="bg-image-right"
      />
      <img 
        src="https://customer-assets.emergentagent.com/job_d690f70b-574f-42dc-be44-392b85b82530/artifacts/i4w18itu_9.png" 
        alt="Background Center" 
        className="bg-image-center"
      />

      <h1 style={{
        fontSize: 'clamp(32px, 5vw, 48px)',
        marginBottom: '40px',
        letterSpacing: '3px',
        textAlign: 'center',
        color: '#DA3D57',
        fontWeight: 'bold',
        position: 'relative',
        zIndex: 1
      }} data-testid="step4-heading">
        {heading}
      </h1>

      <div style={{
        width: '100%',
        maxWidth: '1400px',
        position: 'relative',
        zIndex: 1
      }}>
        {/* Hair Section */}
        <div style={{ marginBottom: '30px' }}>
          <h2 style={{
            fontSize: 'clamp(20px, 3.5vw, 28px)',
            marginBottom: '15px',
            letterSpacing: '2px',
            color: '#DA3D57',
            fontWeight: 'bold',
            textAlign: 'center'
          }}>
            Hair Style
          </h2>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            overflowX: 'auto',
            gap: '15px',
            padding: '10px 20px',
            scrollbarWidth: 'thin'
          }}>
            {hairOptions.map((option, index) => (
              <div
                key={index}
                style={{
                  minWidth: '120px',
                  flexShrink: 0,
                  textAlign: 'center'
                }}
              >
                <div
                  className={`media-item ${selectedHair === option.label ? 'selected' : ''}`}
                  onClick={() => handleHairSelect(option.label)}
                  style={{
                    width: '120px',
                    height: '170px',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    marginBottom: '8px'
                  }}
                  data-testid={`hair-option-${index}`}
                >
                  <img src={option.url} alt={option.label} />
                </div>
                <div style={{
                  fontSize: '14px',
                  color: '#DA3D57',
                  fontWeight: 'bold'
                }}>
                  {option.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Eye Section */}
        <div>
          <h2 style={{
            fontSize: 'clamp(20px, 3.5vw, 28px)',
            marginBottom: '15px',
            letterSpacing: '2px',
            color: '#DA3D57',
            fontWeight: 'bold',
            textAlign: 'center'
          }}>
            Eye Color
          </h2>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            overflowX: 'auto',
            gap: '15px',
            padding: '10px 20px',
            scrollbarWidth: 'thin'
          }}>
            {eyeOptions.map((option, index) => (
              <div
                key={index}
                style={{
                  minWidth: '120px',
                  flexShrink: 0,
                  textAlign: 'center'
                }}
              >
                <div
                  className={`media-item ${selectedEye === option.label ? 'selected' : ''}`}
                  onClick={() => handleEyeSelect(option.label)}
                  style={{
                    width: '120px',
                    height: '170px',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    marginBottom: '8px'
                  }}
                  data-testid={`eye-option-${index}`}
                >
                  <img src={option.url} alt={option.label} />
                </div>
                <div style={{
                  fontSize: '14px',
                  color: '#DA3D57',
                  fontWeight: 'bold'
                }}>
                  {option.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <button
        className="btn-primary"
        onClick={handleNext}
        disabled={!selectedHair || !selectedEye}
        style={{
          marginTop: '40px',
          position: 'relative',
          zIndex: 1
        }}
        data-testid="step4-next-button"
      >
        Next
      </button>
    </div>
  );
};

export default Step4Appearance;
